import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-affectation-management',
  templateUrl: './affectation-management.component.html',
  styleUrls: ['./affectation-management.component.css']
})
export class AffectationManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
